module.exports = __webpack_public_path__ + "img/EB-GC9738.ed8e0359.jpg";